import React, { useState, useEffect, useRef } from 'react';
import ArrowBack from '../../assets/icons/arrow-back.svg'
import Eye from '../../assets/icons/eye.svg'
import HideEye from '../../assets/icons/close-eye.svg'
import BlueLogo from '../../assets/images/blue-logo.svg'
import { Form } from 'react-bootstrap';
import 'primeicons/primeicons.css';
import moment from 'jalali-moment';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { loginByPass, register } from "../../utils/api"
import Loader from '../loader/loader'
import { Toast } from 'primereact/toast';
import { useLocation } from "react-router-dom";
import { useDispatch } from 'react-redux';
import useToastNotification from '../../hooks/useToastNotification';
function SignUp() {
    const dispatch = useDispatch();
    const toast = useRef(null);
    const [time, setTime] = useState(120); // Initialize with 3 minutes (180 seconds)
    const [isActive, setIsActive] = useState(false);
    const [registerValidated, setRegisterValidated] = useState(false);

    // Get the location object from useLocation hook
    const location = useLocation();

    //field
    const [mobile, setMobile] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [natinalCode, setNatinalCode] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfitmPassword] = useState('');
    const [birthDate, setBirthDay] = useState(null);



    const { showError, showSuccess } = useToastNotification();


    // Register form submission
    const registerForm = async (event) => {
        if (event) {
            event.preventDefault();
            const form = event.currentTarget;
            if (form.checkValidity() === true) {
                if (password === confirmPassword) {
                    let payload = { mobile, firstName, lastName, natinalCode, password, birthDate };
                    try {
                        const res = await register(payload);
                        if (res.data.isSuccess) {
                            showSuccess({ text: "ثبت‌ نام با موفقیت انجام شد" });
                            loginByPassWord()
                        } else {
                            showError({ text: res.data.message });
                        }
                    } catch (error) {
                        showError({ text: "خطا در ارتباط با سرور" });
                    }
                } else {
                    showError({ text: 'رمز عبور یکسان نمی باشد' });
                }
            }
            setRegisterValidated(true);
        }
    };

//loginbypass
const loginByPassWord = async (e) => {
      try {
        let pay = {
          password,
          mobile
        }
        let res = await loginByPass(pay)
        if (res.statusText == "OK") {
          if (res.data.isSuccess) {
            localStorage.setItem('token', JSON.stringify(res.data.data.token))
            localStorage.setItem('userData', JSON.stringify(res.data.data))
            dispatch({type:'SET_CUSTOMER_DATA', payload:res.data.data});
            window.location.href = `/`
  
          } else {
            let message = {
              text: res.data.message
            }
            showError(message)
            // window.location.href = `/sign-up?mobile=${mobile}`
          }
  
        }
      } catch (error) {
        let message = {
          text: 'خطا در ارتباط با سرور'
        }
        showError(message)
      }
  
  
  }

    useEffect(() => {
        // Create a new URLSearchParams object to get the query parameters
        const queryParams = new URLSearchParams(location.search);

        // Get the value of the 'mobile' query parameter
        const mobileNumber = queryParams.get("mobile");
        setMobile(mobileNumber)
    }, [])

    //convert to persianDate
    const convertDateToPersian = (date) => {
        if (!date) return '-';
        return moment(date).locale("fa").format("YYYY/MM/DD");
    };
    const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"]

    return (
        <>
            <Toast ref={toast} />

            <div>
                <div className='body-login container'>
                    <div className='login-card'>
                        <button className='btn btn-primary d-flex back-btn' onClick={() => window.location.href = '/sign-up'} > <img src={ArrowBack} className='ml-2' alt="" />بازگشت</button>

                        <div className='item' style={{ marginTop: '6em' }}>
                            <div className='d-flex align-items-center f-32 font-black color-primary title gap-2'><img src={BlueLogo} alt="" />به کادونا خوش آمدید</div>
                            <h6 className='text-xl font-medium	color-primary2 mt-5'>جهت ثبت نام در کادونا، اطلاعات را کامل کنید.</h6>
                            <Form className='mt-2 row gy-3' style={{ marginBottom: '6em' }} noValidate validated={registerValidated} onSubmit={(e) => registerForm(e)} >
                                <div className='col-md-6 col-lg-6 col-sm-12'>
                                    <Form.Group >
                                        <Form.Label style={{ fontWeight: '600' }}>نام</Form.Label>
                                        <Form.Control type="text" required
                                            value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                                        <Form.Control.Feedback type="invalid">
                                            نام را وارد کنید
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </div>
                                <div className='col-md-6 col-lg-6 col-sm-12'>
                                    <Form.Group >
                                        <Form.Label style={{ fontWeight: '600' }}>نام خانوادگی</Form.Label>
                                        <Form.Control type="text" required
                                            value={lastName} onChange={(e) => setLastName(e.target.value)} />
                                        <Form.Control.Feedback type="invalid">
                                            نام خانوادگی را وارد کنید
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </div>
                                <div className='col-md-6 col-lg-6 col-sm-12'>
                                    <Form.Group >
                                        <Form.Label style={{ fontWeight: '600' }}>کدملی</Form.Label>
                                        <Form.Control type="number" inputMode="numeric"  required
                                            value={natinalCode} onChange={(e) => setNatinalCode(e.target.value)} />
                                        <Form.Control.Feedback type="invalid">
                                            کدملی را وارد کنید
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </div>
                                <div className='col-md-6 col-lg-6 col-sm-12'>
                                    <Form.Group >
                                        <Form.Label style={{ fontWeight: '600' }}>شماره موبایل</Form.Label>
                                        <Form.Control type="number" inputMode="numeric"  disabled required
                                            value={mobile} onChange={(e) => setMobile(e.target.value)} />
                                    </Form.Group>
                                </div>
                                <div className='col-md-6 col-lg-6 col-sm-12'>
                                    <Form.Group >
                                        <Form.Label style={{ fontWeight: '600' }}>تاریخ تولد</Form.Label>
                                        <DatePicker
                                            required
                                            weekDays={weekDays}
                                            value={birthDate}
                                            onChange={(date) => setBirthDay(convertDateToPersian(date.toDate()))}
                                            calendar={persian}
                                            locale={persian_fa}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            تاریخ تولد را وارد کنید
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </div>
                                <div className='col-md-6 col-lg-6 col-sm-12'>
                                    <Form.Group controlId="text" >
                                        <Form.Label style={{ fontWeight: '600' }}>رمز عبور</Form.Label>
                                        <Form.Control required
                                            className='number'
                                            type='password'
                                            value={password} onChange={(e) => setPassword(e.target.value)}
                                        />

                                        <Form.Control.Feedback type="invalid">
                                            لطفا رمزعبور را وارد کنید
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </div>
                                <div className='col-md-6 col-lg-6 col-sm-12'>
                                    <Form.Group controlId="text" >
                                        <Form.Label style={{ fontWeight: '600' }}>تکرار رمز عبور</Form.Label>

                                        <Form.Control required
                                            className='number'
                                            type='password'
                                            value={confirmPassword} onChange={(e) => setConfitmPassword(e.target.value)}
                                        />

                                        <Form.Control.Feedback type="invalid">
                                            لطفا رمزعبور را تکرار کنید
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </div>
                                <button className='btn btn-primary w-100 mt-1 text-center mt-4' type='submit' style={{ width: 'auto' }}>ادامه</button>
                            </Form>
                        </div>
                    </div>


                </div>
            </div>


        </>
    )

}
export default SignUp;
